import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  FallOutlined,
  InfoCircleOutlined,
  LoadingOutlined,
  RiseOutlined,
} from "@ant-design/icons";
import { Drawer, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { summaryService } from "../api";
import {
  setProduct,
  setReferences,
  setReferencesFilter,
} from "../redux/actions";
import {
  getMainProduct,
  getProduct,
  getProducts,
  getReferencesFilter,
  getThread,
} from "../redux/selectors";
import { getFeedFilter } from "../redux/selectors/feed-filter.selectors";
import { useAppDispatch } from "../redux/store/hooks";
import { calcChange } from "../scripts/utils";
import BarChart from "./BarChart";
import TonalStatistic from "./TonalStatistic";

const NumberOfMentions: React.FC = () => {
  const thread = useSelector(getThread);
  const product = useSelector(getProduct);
  const mainProduct = useSelector(getMainProduct);
  const products = useSelector(getProducts);
  const feedFilter = useSelector(getFeedFilter);
  const [loading, setLoading] = useState(true);
  const [loadingMentions, setLoadingMentions] = useState(true);
  const [loadingGraph, setLoadingGraph] = useState(true);
  const [competitors, setCompetitors] = useState([]);
  const [graphData, setGraphData] = useState<any>([]);
  const [totalMentions, setTotalMentions] = useState(0);
  const [client, setClient] = useState("");
  const [previousMentions, setPreviousMentions] = useState(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const referencesFilter = useSelector(getReferencesFilter);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setLoading(true);
    if (thread && product && mainProduct) {
      let params = {
        thread_id: +thread.id,
        product_id: window.location.pathname.includes("main")
          ? mainProduct?.id
          : product,
        from: feedFilter.from.slice(0, 10) + " 00:00:00",
        to: feedFilter.to.slice(0, 10) + " 23:59:59",
      };
      setLoadingMentions(true);
      summaryService
        .loadMediaIndexInfo(params)
        .then((resp) => {
          setCompetitors(resp.competitors.items);
          setTotalMentions(resp.client.mentions);
          setClient(resp.client.title);
          let calc = calcChange(
            resp.client.mentions,
            resp.client.previous.mentions
          );

          setPreviousMentions(+calc);
          setLoadingMentions(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [thread, product, feedFilter, mainProduct]);

  useEffect(() => {
    setLoadingGraph(true);
    if (thread && product && mainProduct) {
      let dateDiff =
        (new Date(feedFilter.to).getTime() -
          new Date(feedFilter.from).getTime()) /
        86400000;

      let params = {
        thread_id: +thread.id,
        product_id: window.location.pathname.includes("main")
          ? mainProduct?.id
          : product,
      };
      let params2 = {
        thread_id: +thread.id,
        from: feedFilter.from.slice(0, 10) + " 00:00:00",
        to: feedFilter.to.slice(0, 10) + " 23:59:59",
        filter: {
          network_id: thread?.networks,
          referenceFilter: referencesFilter,
        },
      };
      if (dateDiff >= 28) {
        summaryService
          .loadClientGraph(params)
          .then((resp) => {
            let arr = resp.map((item: any, id: number) => {
              item.netural = (item.count * Number(item.netural)) / 100;
              item.negative = (item.count * Number(item.negative)) / 100;
              item.positive = (item.count * Number(item.positive)) / 100;
              return item;
            });
            console.log("jjjjjj", arr);
            setGraphData(arr);
            setLoadingGraph(false);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        summaryService
          .loadTrustViewsGraph(params2)
          .then((resp) => {
            let arr = resp.smi.map((item: any, id: number) => {
              item.graph_date = item.item_date;
              item.netural = item.netural + resp.social[id].netural;
              item.negative = item.negative + resp.social[id].negative;
              item.positive = item.positive + resp.social[id].positive;
              return item;
            });
            setGraphData(arr);
            setLoadingGraph(false);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, [thread, product, mainProduct, feedFilter, referencesFilter]);

  const changeDist = (competitor: any) => {
    let prod = products.find(
      (it: any) => it?.client?.id == competitor.reference_item_id
    )?.id;
    dispatch(setProduct(prod));
    dispatch(setReferencesFilter([competitor.reference_item_id]));
    dispatch(setReferences([competitor.reference_item_id]));
    if (window.location.pathname.includes("main")) navigate("/districts");
  };

  const changeDistThread = (competitor: any) => {
    let prod = products.find(
      (it: any) => it?.client?.id == competitor.reference_item_id
    )?.id;
    dispatch(setProduct(prod));
    dispatch(setReferencesFilter([competitor.reference_item_id]));
    dispatch(setReferences([competitor.reference_item_id]));
    navigate("/thread");
  };

  return (
    <div className="white-block">
      <div className="grid2-1">
        <div>
          <div className="flex-space">
            <div>
              <p className="block-title">
                Количество упоминаний {!loadingMentions && client}
                <InfoCircleOutlined className="info" onClick={showDrawer} />
              </p>
            </div>
          </div>

          {loadingMentions ? (
            <div className="feed-posts-loader">
              <LoadingOutlined />
            </div>
          ) : (
            <div>
              <div className="flex margin-bottom mobile-flex">
                <div className="title-big">
                  {totalMentions?.toLocaleString()}
                </div>
                <Tooltip
                  color={"#7856FE"}
                  title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
                >
                  {previousMentions > 0 ? (
                    <div className="green green-bg">
                      <RiseOutlined /> +{previousMentions?.toFixed(2)}%
                    </div>
                  ) : (
                    <div className="red red-bg">
                      <FallOutlined /> {previousMentions?.toFixed(2)}%
                    </div>
                  )}
                </Tooltip>
              </div>
              {/*<p className="block-title">Конкуренты</p>*/}
              <div className="grid4 margin-bottom">
                {competitors
                  ?.sort((a: any, b: any) => a.title.localeCompare(b.title))
                  .map((competitor: any, id) => (
                    <div className="flex" key={id}>
                      <div className="small-img-frame">
                        <img
                          src={
                            mainProduct?.client?.title == "Ярославская область"
                              ? "/yar.svg"
                              : "/gov.svg"
                          }
                          alt=""
                        />
                      </div>
                      <div>
                        <p
                          className="grey btn-cursor"
                          onClick={() => changeDist(competitor)}
                        >
                          {competitor?.title}
                        </p>
                        <div
                          className="flex-baseline btn-cursor"
                          onClick={() => changeDistThread(competitor)}
                        >
                          <div className="title-small">
                            {competitor?.mentions}
                          </div>
                          <Tooltip
                            color={"#7856FE"}
                            title="Процент роста/спада показателей, по сравнению с предыдущим периодом"
                          >
                            <div
                              className={
                                competitor?.previous.mentions >=
                                competitor?.mentions
                                  ? "red"
                                  : "green"
                              }
                            >
                              {calcChange(
                                competitor?.mentions,
                                competitor?.previous.mentions
                              )}
                              %
                              {competitor?.previous.mentions >=
                              competitor?.mentions ? (
                                <ArrowDownOutlined />
                              ) : (
                                <ArrowUpOutlined />
                              )}
                            </div>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
          {loadingGraph ? (
            <div className="feed-posts-loader" style={{ height: "300px" }}>
              <LoadingOutlined />
            </div>
          ) : (
            <BarChart graphData={graphData} />
          )}
        </div>
        <TonalStatistic />
      </div>
      <Drawer title="Что отображает этот график?" onClose={onClose} open={open}>
        <div className="overflow-block">
          <p className="purple-border">
            График количества упоминаний иллюстрирует количество упоминаний
            вашего бренда в различных социальных сетях за последний год
          </p>

          <p className="title-small">Источники данных</p>
          <ul>
            <li>Telegram</li>
            <li>Вконтакте</li>
            <li>Одноклассники</li>
            <li>Youtube</li>
            <li>Дзен</li>
          </ul>
          <p className="gray-block">
            <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в
            реальном времени, что позволяет вам следить за актуальными трендами
            и реакцией аудитории на ваш контент
          </p>
        </div>
      </Drawer>
      <Drawer
        title="Что отображает этот график?"
        onClose={() => setOpenDrawer(false)}
        open={openDrawer}
      >
        <div className="overflow-block">
          <p className="purple-border">
            График Share of voice иллюстрирует долю упоминаний компании в общем
            потоке публикаций об отрасли за выбранный период времени. Формула -
            SoV (%) = Количество публикации о компании / Общее количество
            публикаций в отрасли.
          </p>
          <p className="title-small">Как интерпретировать данные</p>
          <ol>
            <li>
              Цветовая кодировка: Разные цвета на графике обозначают ваш бренд и
              конкурентов. Это позволяет легко сравнивать уровень упоминаний.
            </li>
            <li>
              Временные интервалы: Вы можете выбрать различные временные
              интервалы для анализа динамики упоминаний.
            </li>
          </ol>
          <p className="title-small">Источники данных</p>
          <ul>
            <li>Telegram</li>
            <li>Вконтакте</li>
            <li>Одноклассники</li>
            <li>Youtube</li>
            <li>Дзен</li>
          </ul>
          <p className="gray-block">
            <p className="gray-title">ПРИМЕЧАНИЕ</p>Данные обновляются в
            реальном времени, что позволяет вам следить за актуальными трендами
            и реакцией аудитории на ваш контент
          </p>
        </div>
      </Drawer>
    </div>
  );
};

export default NumberOfMentions;
